import { render, staticRenderFns } from "./pos-addClientPayment.vue?vue&type=template&id=2da55296"
import script from "./pos-addClientPayment.vue?vue&type=script&lang=js"
export * from "./pos-addClientPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports